import { customizeMetalData } from "@/constData/customizeMetalData/index.js";
export default {
  state: {
    customizeMetalData: customizeMetalData,
  },
  getters: {
    customizeMetalData: (state) => {
      return state.customizeMetalData;
    },
    customizeMetalEngravingContentTypeByComponentCode: ({
      customizeMetalData,
    }) => {
      return (code) => {
        return customizeMetalData.filter((i) => i.code === code)[0]
          .engravingContentType;
      };
    },
    customizeMetalDataByComponentCode: ({ customizeMetalData }) => {
      return (code) => {
        return customizeMetalData.filter((i) => i.code === code)[0];
      };
    },
    customizeMetalDataByShape: ({ customizeMetalData }) => {
      return (shape) => {
        return customizeMetalData.filter((i) => i.shape === shape);
      };
    },
    defaultComponentCodeByShape: ({ customizeMetalData }) => {
      return (shape) => {
        return customizeMetalData.filter((i) => i.shape === shape)[0].code;
      };
    },
    customizeMetalNameByComponentCode: ({ customizeMetalData }) => {
      return (code) => {
        return customizeMetalData.filter((i) => i.code === code)[0].name;
      };
    },
    defaultAccessoryByComponentCode: ({ customizeMetalData }) => {
      return (code) => {
        return customizeMetalData.find((i) => i.code === code).accessory[0];
      };
    },
    accessoryByComponentName: ({ customizeMetalData }) => {
      return (name) => {
        return customizeMetalData.find((i) => i.name === name).accessory;
      };
    },
    textSettingByComponentCode: ({ customizeMetalData }) => {
      return (code) => {
        return customizeMetalData.find((i) => i.code === code).textSetting;
      };
    },
    customizeMetalByComponentCode: ({ customizeMetalData }) => {
      return (code) => {
        return customizeMetalData.filter((i) => i.code === code)[0];
      };
    },
    wayByComponentName: ({ customizeMetalData }) => {
      return (name) => {
        return customizeMetalData.find((i) => i.name === name).way;
      };
    },
    isCustomizeByComponentCode: ({ customizeMetalData }) => {
      return (code) => {
        return !!customizeMetalData.find((i) => i.code === code).textSetting;
      };
    },
  },
};
